<div class="dl-page dl-page--narrow">
  <div class="header">
    <h1>Add New Partner</h1>
    <button class="dl-btn" (click)="onCancel()" [disabled]="loading">
      <mat-icon>arrow_back</mat-icon>
      Back to Partners
    </button>
  </div>

  <!-- Success message -->
  <div *ngIf="success" class="success-message">
    <p>
      <mat-icon>check_circle</mat-icon>
      ✅ Partner created successfully! Redirecting to partners list...
    </p>
  </div>

  <!-- Error message -->
  <div *ngIf="error" class="error-message">
    <p>
      <mat-icon>error</mat-icon>
      {{ error }}
    </p>
  </div>

  <!-- Form -->
  <form *ngIf="!success" (ngSubmit)="onSubmit()" class="partner-form">
    <div class="dl-filters">
      <!-- Basic Information -->
      <div class="dl-card">
        <h3>
          <mat-icon>business</mat-icon>
          Basic Information
        </h3>
        
        <div class="dl-field">
          <label class="dl-field__label" for="name">Partner Name *</label>
          <input
            type="text"
            id="name"
            [(ngModel)]="partner.contact.name"
            name="name"
            required
            placeholder="Enter partner name"
            [disabled]="loading"
          class="dl-input"/>
        </div>

        <div class="dl-field">
          <label class="dl-field__label" for="partnerType">Partner Type</label>
          <select
            id="partnerType"
            [(ngModel)]="partner.type"
            name="partnerType"
            [disabled]="loading"
          class="dl-select">
            <option *ngFor="let type of partnerTypes" [value]="type.value">
              {{ type.label }}
            </option>
          </select>
        </div>

        <div class="dl-field">
          <label class="dl-field__label">Partner Logo</label>
          <app-file-upload
            acceptedTypes="image/*"
            [maxSize]="5242880"
            placeholder="Drag & drop logo image here or click to select"
            [currentFile]="logoAttachment"
            [disabled]="loading || isUploadingLogo"
            (fileSelected)="onLogoFileSelected($event)"
            (fileRemoved)="onLogoRemoved()">
          </app-file-upload>
        </div>
      </div>

      <!-- Contact Information -->
      <div class="dl-card">
        <h3>
          <mat-icon>contact_phone</mat-icon>
          Contact Information
        </h3>
        
        <div class="dl-field">
          <label class="dl-field__label" for="email">Email *</label>
          <input
            type="email"
            id="email"
            [(ngModel)]="partner.contact.email"
            name="email"
            required
            placeholder="Enter email address"
            [disabled]="loading"
          class="dl-input"/>
        </div>

        <div class="dl-field">
          <label class="dl-field__label" for="phoneNumber">Phone Number *</label>
          <input
            type="tel"
            id="phoneNumber"
            [(ngModel)]="partner.contact.phoneNumber"
            name="phoneNumber"
            required
            placeholder="Enter phone number"
            [disabled]="loading"
          class="dl-input"/>
        </div>

        <div class="dl-field">
          <label class="dl-field__label" for="faxNo">Fax Number</label>
          <input
            type="tel"
            id="faxNo"
            [(ngModel)]="partner.faxNo"
            name="faxNo"
            placeholder="Enter fax number"
            [disabled]="loading"
          class="dl-input"/>
        </div>
      </div>

      <!-- Address Information -->
      <div class="dl-card">
        <h3>
          <mat-icon>location_on</mat-icon>
          Address Information
        </h3>
        
        <div class="dl-field">
          <label class="dl-field__label" for="street">Street</label>
          <input
            type="text"
            id="street"
            [(ngModel)]="partner.contact.address.street"
            name="street"
            placeholder="Enter street address"
            [disabled]="loading"
          class="dl-input"/>
        </div>

        <div class="dl-field">
          <label class="dl-field__label" for="city">City</label>
          <input
            type="text"
            id="city"
            [(ngModel)]="partner.contact.address.city"
            name="city"
            placeholder="Enter city"
            [disabled]="loading"
          class="dl-input"/>
        </div>

        <div class="dl-field">
          <label class="dl-field__label" for="state">State</label>
          <input
            type="text"
            id="state"
            [(ngModel)]="partner.contact.address.state"
            name="state"
            placeholder="Enter state"
            [disabled]="loading"
          class="dl-input"/>
        </div>

        <div class="dl-field">
          <label class="dl-field__label" for="zip">ZIP Code</label>
          <input
            type="text"
            id="zip"
            [(ngModel)]="partner.contact.address.zip"
            name="zip"
            placeholder="Enter ZIP code"
            [disabled]="loading"
          class="dl-input"/>
        </div>
      </div>

      <!-- Bank Accounts Information -->
      <div class="dl-card">
        <h3>
          <mat-icon>account_balance</mat-icon>
          Bank Accounts
        </h3>
        
        <div class="bank-accounts-list">
          <div *ngFor="let bankAccount of partner.bankAccounts; let i = index" class="bank-account-item">
            <div class="bank-account-fields">
              <div class="dl-field">
                <label class="dl-field__label" [for]="'bankName_' + i">Bank Name</label>
                <input
                  type="text"
                  [id]="'bankName_' + i"
                  [(ngModel)]="bankAccount.name"
                  [name]="'bankName_' + i"
                  placeholder="Enter bank name"
                  [disabled]="loading"
                class="dl-input"/>
              </div>
              <div class="dl-field">
                <label class="dl-field__label" [for]="'bankNumber_' + i">Account Number</label>
                <input
                  type="text"
                  [id]="'bankNumber_' + i"
                  [(ngModel)]="bankAccount.number"
                  [name]="'bankNumber_' + i"
                  placeholder="Enter account number"
                  [disabled]="loading"
                class="dl-input"/>
              </div>
            </div>
            <button 
              type="button" 
              class="dl-btn dl-btn--danger-ghost dl-btn--icon dl-btn--sm" 
              (click)="removeBankAccount(i)" 
              [disabled]="loading"
              matTooltip="Remove bank account">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
        
        <button 
          type="button" 
          class="dl-btn dl-btn--sm" 
          (click)="addBankAccount()" 
          [disabled]="loading">
          <mat-icon>add</mat-icon>
          Add Bank Account
        </button>
      </div>
    </div>

    <!-- Form Actions -->
    <div class="form-actions">
      <button type="button" class="dl-btn dl-btn--ghost" (click)="resetForm()" [disabled]="loading">
        <mat-icon>refresh</mat-icon>
        Reset Form
      </button>
      <button type="button" class="dl-btn" (click)="onCancel()" [disabled]="loading">
        <mat-icon>cancel</mat-icon>
        Cancel
      </button>
      <button type="submit" class="dl-btn dl-btn--primary" [disabled]="loading || !partner.contact.name.trim() || !partner.contact.email.trim() || !partner.contact.phoneNumber.trim()">
        <mat-icon *ngIf="!loading">add</mat-icon>
        <mat-icon *ngIf="loading" class="form-spin">hourglass_empty</mat-icon>
        <span *ngIf="!loading">Create Partner</span>
        <span *ngIf="loading">Creating...</span>
      </button>
    </div>
  </form>
</div>